import { prefixesToDomainMap } from '@r1-frontend/geo/data/prefixesToDomainMap';

export const getCityDomainByAgreement = (agreement: string): string | undefined => {

    const foundedPrefixToDomain = prefixesToDomainMap.find(({ prefix }) => agreement.startsWith(`${prefix}`));
    if (foundedPrefixToDomain) {
        return foundedPrefixToDomain.domain;
    }
};
